// Override default components.
// See https://github.com/carbon-design-system/gatsby-theme-carbon/issues/705#issuecomment-582146082
import defaultComponents from "gatsby-theme-carbon/src/components/MDXProvider/defaultComponents";

import ListBadges from "../../../components/ListBadges";

export default {
  ...defaultComponents,
  ListBadges,
};
